export default "__VITE_ASSET__Cjlu$ToO__"